var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"function_box"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"function_value"},[_c('div',{staticClass:"icons"},[_c('img',{attrs:{"src":item.url}}),_c('span',[_vm._v(_vm._s(item.name))])]),_c('div',{staticClass:"introduce"},[_vm._v(_vm._s(item.value))]),_c('div')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }